// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
module.exports = {
  calendar: '55a5d917446f517774210011',
  cardAging: '55a5d917446f517774210012',
  voting: '55a5d917446f517774210013'
};
